export const CrmEntity = Object.freeze({
	Contact: 'CONTACT',
	Company: 'COMPANY',
	Deal: 'DEAL',
});
